// extracted by mini-css-extract-plugin
export default {"container":"PricingToggle_container__+ufpQ","segmented":"PricingToggle_segmented__RJvjW"};